export default __webpack_public_path__ + "static/media/Banner_03.907e7fc4.png";